import { Link, useNavigate } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { DealForm } from '@/components/pipeline/deal-form';

export function NewDealPage() {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Link to="/deals" className="text-muted-foreground hover:text-foreground">
          <ArrowLeft className="h-5 w-5" />
        </Link>
        <div>
          <h1 className="text-2xl font-bold tracking-tight">New Deal</h1>
          <p className="text-muted-foreground">Create a new deal in your pipeline.</p>
        </div>
      </div>

      <DealForm
        onSave={(deal) => {
          if (deal?.id) {
            void navigate({ to: '/deals/$dealId', params: { dealId: deal.id } });
          } else {
            void navigate({ to: '/deals' });
          }
        }}
        onCancel={() => void navigate({ to: '/deals' })}
      />
    </div>
  );
}
